{
  "main": {
    "title": "Pilot Directory",
    "nazaj": "Back"
  },
  "navs": {
    "vnos": "Input",
    "seznam": "List"
  },
  "search": {
    "placeholder": "Search by code, first name, or last name"
  },
  "table": {
    "sifra": "Code",
    "ime": "First Name",
    "priimek": "Last Name",
    "podrobno": "Details"
  },
  "modal": {
    "sifra": "Code:",
    "naslov": "Address:",
    "posta": "Postal Code:",
    "kraj": "City:",
    "email": "Email:",
    "telefon": "Phone:",
    "klub": "Club:",
    "naletJ": "Glider hours:",
    "naletM": "Motor hours:",
    "opomba": "Note:",
    "instruktor": "Instructor:",
    "instruktorJ": "Instructor glider:",
    "instruktorUL": "Instructor ultralight:",
    "vlecniR": "Tow rating",
    "jadralniP": "A glider pilot?",
    "motorniP": "A pilot of a motorized aircraft?",
    "ultraP": "A ultralight pilot?"
  },
  "vabilo": {
    "title": "Scan QR code",
    "opomba": "User already has access to the application!"
  },
  "labels": {
    "ime": "First Name",
    "priimek": "Last Name",
    "naslov": "Address",
    "posta": "Postal Code",
    "kraj": "City",
    "email": "Email",
    "telefon": "Phone",
    "klub": "Club",
    "klubI": "Select club:",
    "naletJ": "Glider hours:",
    "naletM": "Motor hours:",
    "opomba": "Note:",
    "instruktor": "Instructor:",
    "instruktor": "Instructor glider:",
    "instruktorUL":"Instructor ultralight:",
    "vlecniR": "Tow rating:",
    "jadralniP": "Glider pilot",
    "motorniP": "Powered aircraft pilot",
    "ultraP": "Ultralight pilot",
    "licenca": "License:"
  },
  "buttons": {
    "csv": "Export to CSV",
    "povabi": "Invite",
    "deli": "Share",
    "uredi": "Edit",
    "posodobi": "Update data",
    "izbrisi": "Delete",
    "brisiIzbiro": "Clear selection"
  }
}